import { realBricksApi } from '../../utils/axiosInterceptors';

export const getUserProfileApi = async () => {
  const response = await realBricksApi.get(`/api/v1/user/profile`);
  return response.data;
};
export const updateUserProfile = async (data) => {
  const response = await realBricksApi.put(`/api/v1/user/profile`, data);
  return response.data;
};
export const updateUserAgreements = async (data) => {
  const response = await realBricksApi.put(`/api/v1/user/agreements`, data);
  return response.data;
};
export const getCountrysApi = async (data) => {
  const response = await realBricksApi.get(`/api/v1/countries?page=${data?.page}&perPage=${data?.perPage}`);
  return response.data;
};
export const getStatesApi = async (data) => {
  const response = await realBricksApi.get(`/api/v1/states?page=${data?.page}&perPage=${data?.perPage}`);
  return response.data;
};
export const getPreSignedUrl = async (fileType, docType, displayView, fileName) => {
  let url = `/api/v1/documents/pre-sign-url/?fileType=${fileType}&displayView=${displayView}`;

  if (docType) {
    url += `&docType=${docType}`;
  } else if (fileName) {
    url += `&fileName=${fileName}`;
  }

  const response = await realBricksApi.get(url);
  return response.data;
};
export const kycAmlVerify = async () => {
  const response = await realBricksApi.get(`/api/v1/user/kyc-aml-verify`);
  return response.data;
};

export const dwollaAgreementsApi = async (data, { rejectWithValue }) => {
  const { onFail = () => {}, onSuccess = () => {} } = data;
  try {
    const response = await realBricksApi.put(`/api/v1/user/dwolla-agreements`);
    onSuccess();
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const acceptAgreementApi = (policyName, isAccepted) => {
  return realBricksApi.post(
    `/api/v1/legal/accept-agreement`,
    {},
    {
      params: {
        policyName,
        isAccepted,
      },
    }
  );
};
